import _range from 'lodash/range';

import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';

import Validator from 'services/Validator';

import './password-meter.scss';

const PASSWORD_STRENGTH_CONFIG = [
    { maxScore: 1, color: '#D40031' },
    { maxScore: 2, color: '#FF6B00' },
    { maxScore: 3, color: '#FFD600' },
    { maxScore: 5, color: '#00B67F' }
];

const VALIDATION_RULES = ['hasMinLength', 'hasLowercase', 'hasUppercase', 'hasNumber', 'hasSpecialChar'];

const CustomPasswordMeterV2 = ({ value }) => {
    const passwordValidation = useMemo(() => {
        return value ? Validator.getPasswordValidation(value) : null;
    }, [value]);

    const calculatePasswordStrength = useCallback((validator) => {
        if (!validator) {
            return { score: 0, color: '#EBECEE' };
        }

        // Calculate score based on validation rules
        let score = VALIDATION_RULES.reduce((acc, rule) => acc + (validator[rule] ? 1 : 0), 0);

        // Penalize if max length is not met
        if (!validator.hasMaxLength) {
            score = Math.max(0, score - 1);
        }

        // Determine color based on score
        const colorConfig = PASSWORD_STRENGTH_CONFIG.find((config) => score <= config.maxScore);
        const color = colorConfig?.color || '#EBECEE';

        return { score: Math.min(score, 5), color };
    }, []);

    const hasErrors =
        !passwordValidation || !passwordValidation.hasNoNonAscii || !passwordValidation.hasNoLeadingOrTrailingSpaces;

    const passwordStrength = calculatePasswordStrength(passwordValidation);

    if (hasErrors) {
        return null;
    }

    return (
        <div className='password-meter__container'>
            {_range(5).map((item) => {
                const isActive = item < passwordStrength.score;

                return (
                    <div
                        key={`password-meter-${item}`}
                        className='password-meter__item'
                        style={{
                            backgroundColor: isActive ? passwordStrength.color : '#ebecee'
                        }}
                    />
                );
            })}
        </div>
    );
};

export default CustomPasswordMeterV2;

CustomPasswordMeterV2.propTypes = {
    value: PropTypes.string
};
